import { HttpErrorService } from '@/services/HttpError.service'
import { captchaErrorHandbook } from '@/models/Errors'
import type { CaptchaResponse } from '@/models'
import { HttpService } from '@/services/Http.service'

export class CaptchaService {
  private httpErrorService: HttpErrorService<keyof typeof captchaErrorHandbook>
  private endpoint = '/captcha'
  private httpService: HttpService

  constructor(httpService: HttpService) {
    this.httpService = httpService
    this.httpErrorService = new HttpErrorService(
      captchaErrorHandbook,
      'captcha',
    )
  }

  async verify(token: string) {
    const url = [this.endpoint, 'verify'].join('/')

    return await this.httpService
      .post<CaptchaResponse>(url, {
        requestConfig: {
          cancellable: true,
          needCancelAtChangeRoute: true,
          forceRequest: true,
        },
        fetchConfig: {
          body: {
            captcha: {
              token,
              version: 3,
            },
          },
        },
      })
      .catch((error) => {
        throw this.httpErrorService.getThrowingError(error, url)
      })
  }
}
